var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"bg-gray-3"},[(_vm.isSaving)?_c('span',{staticClass:"cl-gray-50 no-select"},[_vm._v(" Salvando... ")]):_c('span',{staticClass:"cl-gray-50 no-select"},[_vm._v(" Salvo automaticamente às "+_vm._s(_vm._f("formatDateTime")(_vm.savedOn))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }